<template>

	<div>
      
	  	<div v-if="$route.path == '/zmist'">

      		<div class="illustration">
        		<img src="images/Antkiv.jpg" style="border: 2px solid #fff; border-radius: 10px">
      		</div> 
      		<div class="block">
      			<div class="content">
	      			<router-link :to="{ name: 'Song', params: { slug: '1' }}">Отче наш (Київський розспів)</router-link><hr>
			        <router-link :to="{ name: 'Song', params: { slug: '2' }}">Отче наш (Бере́зівський розспів)</router-link><hr>
			        <router-link :to="{ name: 'Song', params: { slug: '3' }}">Блажен муж</router-link><hr>
			        <router-link :to="{ name: 'Song', params: { slug: '4' }}">О, горе мні грішнику</router-link><hr>
			        <router-link :to="{ name: 'Song', params: { slug: '5' }}">Благослови, душе моя, Господа</router-link><hr>
			        <router-link :to="{ name: 'Song', params: { slug: '6' }}">Бог предвічний</router-link><hr>
			        <router-link :to="{ name: 'Song', params: { slug: '7' }}">Нова радість стала</router-link><hr>
			        <router-link :to="{ name: 'Song', params: { slug: '8' }}">Небо і земля</router-link><hr>
			        <router-link :to="{ name: 'Song', params: { slug: '9' }}">Щедрий вечір</router-link><hr>
			        <router-link :to="{ name: 'Song', params: { slug: '10' }}">У надії Божа Мати</router-link><hr>
			        <router-link :to="{ name: 'Song', params: { slug: '11' }}">Добрий вечір тобі, пане господарю!</router-link>
  				</div>
  			</div>
  		</div>
  		<div v-show="$route.path != '/zmist'">

		  	<div class="settings">
		  		Автоматичне відтворення <toggle-button style="margin-left: 5px;" @change="AutoPlay" v-model="auto" color="#fecc89"/>
		  	</div>

		    <div class="block-player">
			    <div class="player-buttom" id="buttom" @click="Play">
			      <img src="@/assets/play.svg" width="32">
			    </div>  
			    <div class="title">
			    	<div id="column-1" style="text-align: left;">
			    		<div @click="Prew"><img src="@/assets/prew.png" width="32"></div>
			    	 	<span style="float: left;">{{ status }}</span>
			    	</div>
					<div id="column-2">
			      		<h1>{{ song.name }}</h1>
			       		<i style="float: center;"><small ref="type">{{ song.type }}</small></i>
			   		</div>
				   	<div id="column-1" style="text-align: right;">
				    	<div @click="Next"><img src="@/assets/next.png" width="32"></div>
				        <span style="float: right;">{{ duration }}</span>
				   	</div>
			    </div>
			    <div class="block-bar">
			      <div class="bar-border">
			      <div class="bar-duration" id="duration" @mousedown="update">
			        <div class="bar-position" id="position"></div>
			        <div class="bar-position-load" id="loading"></div>
			        </div>
			      </div>
			    </div>
			</div>	   
			    
		  
			<div class="illustration">
				<img id="image" src="images/Antkiv.jpg">
			</div>  
			<audio id="player" @timeupdate="progressUpdate">
		    	<source :src="song.music" type="audio/mpeg">
		  	</audio>
	 
			<div class="block">
				<div v-html="song.information" class="text"></div>
			</div>

		</div>

	</div>
    
</template>


<script>

export default {
  
  data() {
    return {
    	auto: false,
	    block1: 'hd',
	    play: 0,
	    status: '0:00',
	    player_buttom: 'p_play',
	    duration: '0:00',
	    text: false,
	    songs: [],
	    position: 0,
	    process: 'p_play',
	    song: {
	    	slug:"/main",
			name:"",
			type:"",
			image:"images/none.jpg",
			music:"mp3/",
			information:"" },
	}    
  },

  components: {
    'p_play': {
      template: '<img src="@/assets/play.svg" width="32">'
    },
    'p_pause': {
      template: '<img src="@/assets/pause.svg" width="32">'
    }, 
  },

  mounted () {
     
    var vid = document.getElementById("player");

	vid.onplay = function() {
	    document.getElementById('buttom').innerHTML = '<img src="/images/pause.svg" width="32">';
	}; 


	vid.onpause = function() {
	    document.getElementById('buttom').innerHTML = '<img src="/images/play.svg" width="32">';
	};


	vid.onwaiting = function() {
	    document.getElementById('buttom').innerHTML = '<img src="/images/loading.svg" width="32">';
	};
	/*/
	vid.onloadeddata = function() {
	    document.getElementById('buttom').innerHTML = '<img src="images/play.svg" width="32">';
	}; 
	*/
	vid.onplaying = function() {
	    document.getElementById('buttom').innerHTML = '<img src="/images/pause.svg" width="32">';
	}; 

  },
  created: function() {

   // this.Animation('name_logo');
  
  
  //this.PlayerLoad()

   this.$http.get('songs.json').then(function (response) { 

   		this.songs = response.data 

    	var pos = this.songs.find( song => song.slug === this.$route.path )

	    if (!pos) this.$router.push({ path: '/zmist' })

	    this.position = Number(pos.song);

	    this.song = this.songs.find( id => id.song === String(this.position) )

	    document.title = this.song.name
	    player.src = this.song.music

	    if (this.$route.path != '/zmist') this.PlayerLoad();


  }).catch(function (error) {});

    if (this.getCookie('autoplay') == 'true') {
    	this.auto = true

    } else {
    	this.auto = false
    }

  },

  watch: {
    '$route' (to, from) {

	    var pos = this.songs.find( song => song.slug === this.$route.path )

	    if (!pos) this.$router.push({ path: '/zmist' })

	    this.position = Number(pos.song);

	    this.song = this.songs.find( id => id.song === String(this.position) )

	    document.title = this.song.name
	    player.src = this.song.music
	    if (this.$route.path != '/zmist') this.PlayerLoad();

	    //console.log(this.position)

    }
  },
  
  methods: {

  	AutoPlay() {

  		if (this.auto) {
  			document.cookie = "autoplay=true; expires=Tue, 19 Jan 2038 03:14:07 GMT";
  			//console.log('0')
  		} else {
  			document.cookie = "autoplay=false; expires=Tue, 19 Jan 2038 03:14:07 GMT";
  			//console.log('1')
  		}

  	},

  	getCookie(name) {
	  let matches = document.cookie.match(new RegExp(
	    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	  ));
	  return matches ? decodeURIComponent(matches[1]) : undefined;
	},

    PlayerLoad() {

    	console.log('preLoad - '+player.src)

      	let p = document.getElementById('player')
      	//p.load()

      	if (this.auto) {
	    	this.Play()
	    } else {
	    	document.getElementById('buttom').innerHTML = '<img src="/images/play.svg" width="32">';
	    }


    	/* Google Analytics */
    	this.$ga.event({
		  eventCategory: 'song',
		  eventAction: 'listening',
		  eventLabel: this.song.name+' - '+this.$route.path,
		  eventValue: 1
		})


    	setTimeout(() => this.Duration(), 500);

    	
  		//console.log(p.duration)

    },

    Duration() {

    	let p = document.getElementById('player')

    	console.log('duration load... ')

    	if (!p.duration) {
      	// this.player_buttom = 'p_loading';
      		return setTimeout(() => this.Duration(), 1000);
    	}

    	var h = p.duration.toFixed() / 3600 ^ 0;
	    var m = (p.duration.toFixed() - h * 3600) / 60 ^ 0;
	    var s = p.duration.toFixed() - h * 3600 - m * 60;
	    let sec = (s<10?"0"+s:s);
	  
	    this.duration = (m<10?""+m:m)+":"+sec;

	   	this.progressUpdate()

    },

    Play() {

    	if (this.position != 15 && this.position != 12) {

    	if (document.getElementById('player').paused) {

       		// this.PlayerLoad()
	      	document.getElementById('player').play();
	      	this.play = 1;
	     	//his.process = 'p_pause';
	      	//console.log('play');

	    } else {

	      	document.getElementById('player').pause();
	      	this.play = 0;
	     	//his.process = 'p_play'
	      	//console.log('pause');

	    }

		}

   		// this.player_buttom =  this.process;

    },

    Prew: function() {

    	if (this.position == 1) {
	      this.position = 11
	    } else {
	      this.position--
	    }


	    let prew = this.songs.find( id => id.song === String(this.position) )
	    this.$router.push({ path: prew.slug })

    },	

    Next() {

	    if (this.position >= 11) {
	      this.position = 1
	    } else {
	      this.position++
	    }


	    let next = this.songs.find( id => id.song === String(this.position) )
	    this.$router.push({ path: next.slug })

    },

   	progressUpdate() {

   		var positionBar = document.getElementById("position");
   		positionBar.style.width = (player.currentTime / player.duration * 100)  + "%";

   		var r = player.buffered;

  		if (r) {
    		for (var i=0; i<r.length; i++) {
      			var start = r.start(i)/player.duration * 100;
      			var end = r.end(i)/player.duration * 100;
      			var loadingBar = document.getElementById("loading");
    			loadingBar.style.width = Math.max(2, end-start).toFixed(4) + "%";
    		}
  		}


	    var h = player.currentTime.toFixed() / 3600 ^ 0;
	    var m = (player.currentTime.toFixed() - h * 3600) / 60 ^ 0;
	    var s = player.currentTime.toFixed() - h * 3600 - m * 60;
	    let sec = (s<10?"0"+s:s);
	  
	    this.status = (m<10?""+m:m)+":"+sec;


	    if (player.ended) {

	    	this.play = 0;
	      	this.player_buttom = 'p_play';

			if (this.auto) {

				this.Next()

			}
	    }

  	},

	update($event) {

		let d = document.getElementById("duration")
	    let perPixel = player.duration / d.clientWidth;
	    let x = $event.pageX - d.offsetLeft;
	    let dd = x * perPixel

	    player.currentTime = dd.toFixed(3)

	    var positionBar = document.getElementById("position");
	    positionBar.style.width = (dd.toFixed(3) / player.duration * 100)  + "%";

	    //console.log(dd.toFixed(3)+" - "+player.duration);

	  }
   }

 }
</script>